import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {ReportsService} from '../../reports.service';
import {appColors} from '../../../core/styles/colors';
import {EChartsOption} from 'echarts';
import {MatActivityDashboardZoomDialogComponent} from './mat-activity-dashboard-zoom-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {chartDefaultOptions, chartExpandIcon} from '../../../core/styles/chart-defauls';
import { NgxEchartsDirective } from 'ngx-echarts';

@Component({
    selector: 'app-activity-pie-chart',
    templateUrl: './activity-pie-chart.component.html',
    standalone: true,
    imports: [NgxEchartsDirective]
})
export class ActivityPieChartComponent implements OnInit, OnDestroy, OnChanges {

  @Input() public data: any[] = [];
  @Input() showExpand = false;
  @ViewChild('expandBtn') expandBtn;

  colors = appColors;
  updateOptions: EChartsOption = {};
  initOptions = {};

  options: EChartsOption = {
    title: Object.assign({}, chartDefaultOptions.title, {
      text: 'Call Summary By Type'
    }),
    // legend: Object.assign({}, chartDefaultOptions.legend),
    grid: Object.assign({}, chartDefaultOptions.grid),
    toolbox: [{
      show: true,
      feature: {
        dataZoom: {
          yAxisIndex: 'none'
        },
        saveAsImage: {},
        myZoom: {
          show: this.showExpand,
          title: 'Expand',
          icon: chartExpandIcon,
          onclick: () => {
            console.log('on expand click');
            this.expandBtn.nativeElement.click();
          }
        }
      }
    }],
    xAxis: {
      type: 'category',
      boundaryGap: true
    },
    yAxis: {
      type: 'value',
      scale: true,
      min: 0,
      axisLine: {
        show: true,
      },
      name: 'Total Count',
      nameGap: 30,
      nameRotate: 90,
      nameLocation: 'middle'
    },
    series: [{
      type: 'bar',
      name: 'Calls',
      barMaxWidth: 80,
    }
    ],
    tooltip: {
      show: true,
      trigger: 'axis',
    },
  };

  private chart: any;

  constructor(public reportsService: ReportsService, public dialog: MatDialog) {
    const resizeObserver = new ResizeObserver(() => {
      this.resizeChart();
    });
    resizeObserver.observe(document.body);
  }

  ngOnInit() {
    console.log('my on init');
  }

  resizeChart() {
    if (this.chart) {
      this.chart.resize();
    }
  }

  onChartInit($event: any) {
    this.chart = $event;
    console.log('on chart init:', $event);
  }

  ngOnDestroy() {

  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log('my on ngOnChanges');

    this.updateChart();
  }

  updateChart() {

    const groupedData = [...this.data];
    this.options.series![0].data = groupedData.map(item => {
      return {
        itemStyle: {color: item.color},
        value: item.calls,
      };
    });

    this.options.toolbox![0].feature.myZoom.show = this.showExpand;

    this.updateOptions = {
      toolbox: this.options.toolbox,
      series: this.options.series,
      xAxis: {
        data: groupedData.map(item => {
          return item.extension;
        })
      },
    };
  }

  onExpandClick() {
    this.dialog.open(MatActivityDashboardZoomDialogComponent, {
      width: '90%',
      height: '90%',
      data: {
        chartData: this.data,
        dialogTitle: 'Call Summary By Type',
        showActivityPieChart: true,
      }
    });
  }
}
